// Material imports - Should be checked for Tree Shaking (removing unused modules and services from the final bundle.)
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslocoModule } from '@jsverse/transloco';

import { TimeStampUpdatedPipe } from './pipes/timestamp-to-updated-at.pipe';
import { UtcToLocalPipe } from './pipes/utc-to-local.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatCardModule,
    MatDatepickerModule,
    MatDialogModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatIconModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatNativeDateModule,
    MatStepperModule,
    MatPaginatorModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatBadgeModule,
    MatTreeModule,
    MatSliderModule,
    ReactiveFormsModule,
    DragDropModule,
    OverlayModule,
    UtcToLocalPipe,
    TimeStampUpdatedPipe,
  ],
  exports: [
    TranslocoModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatCardModule,
    MatDatepickerModule,
    MatDialogModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatIconModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatNativeDateModule,
    MatStepperModule,
    MatPaginatorModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatBadgeModule,
    MatTreeModule,
    MatSliderModule,
    ReactiveFormsModule,
    DragDropModule,
    OverlayModule,
    UtcToLocalPipe,
    TimeStampUpdatedPipe,
  ],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 500,
        hideDelay: 250,
        position: 'above',
        touchendHideDelay: 1500,
      },
    },
  ],
})
export class SharedUtilCommonModule {}
